export enum DistributionType {
    ToDistribute = 0,
    NDZ = 1,
    Sticker = 2,
    OtherPk = 3,
    FalseAddressPoint = 4
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/distribution-type.ts